<template>

    <div class="card mt-3" style="margin-bottom:10px">
        <div class=" card-body">
            <div class="container">

                <div class="row">

                    <h6 style="background: #0078be!important;" class="card-title bg-primary text-white w-100 p-1 mb-3">
                        SEGUIMIENTO DEL PACIENTE
                    </h6>

                    <!-- Columna para  -->
                    <div class="col-12 col-md-12">

                        <div class="card-body">

                            <div class="d-flex justify-content-between align-items-center mb-2">
                                <!-- Contenedor para los íconos de impresora -->
                                <div class="acciones-seguimiento">
                                    <i class="fas fa-print redes text-primary" style="cursor: pointer;"
                                        @click="Imprimir"></i>

                                    <i class="fas fa-print redes"
                                        style="cursor: pointer; color:#eb1265!important;" @click="Imprimir2"></i>

                                    <button
                                        v-if="tieneReceta"
                                        type="button"
                                        class="btn btn-sm btn-ver-receta"
                                        :disabled="cargandoReceta"
                                        @click="abrirRecetaFirmada"
                                    >
                                        <i class="fas fa-file-prescription me-1"></i>
                                        Ver receta
                                    </button>
                                </div>

                                <!-- Información alineada a la derecha -->
                                <div class="text-end">
                                    <label class="d-block mb-0" style="color: #0078be;">{{ historial.doctor }}</label>
                                    <label class="d-block mb-3" style="color: #f44283; font-size: 14px;">{{
                                        historial.especialidad }}</label>
                                </div>
                            </div>




                            <div class="row">

                                <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3">
                                    <p class="mb-1"><strong>Peso: </strong>{{ signosVitales.peso }}</p>
                                    <p class="mb-1"><strong>Talla: </strong>{{ signosVitales.talla }}</p>
                                    <p class="mb-1"><strong>IMC: </strong>{{ signosVitales.imc }}</p>
                                    <p><strong>Per. Abd: </strong>{{ signosVitales.perimetro_abdominal }}</p>
                                </div>
                                <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3">
                                    <p class="mb-1"><strong>Per. Cef: </strong>{{ signosVitales.perimetro_cefalico }}
                                    </p>
                                    <p class="mb-1"><strong>Pr. Sist: </strong>{{ signosVitales.presion_sistolica }}</p>
                                    <p class="mb-1"><strong>Pr. Dist: </strong>{{ signosVitales.presion_diastolica }}
                                    </p>
                                    <p><strong>Pr. Med: </strong>{{ signosVitales.presion_media }}</p>
                                </div>
                                <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3">
                                    <p class="mb-1"><strong>Temp: </strong>{{ signosVitales.temperatura }}</p>
                                    <p class="mb-1"><strong>FC: </strong>{{ signosVitales.frecuencia_cardiaca }}</p>
                                    <p class="mb-1"><strong>Sat: </strong>{{ signosVitales.saturacion_oxigeno }}</p>
                                    <p><strong>Fr:</strong>{{ signosVitales.frecuencia_respiratoria }}</p>
                                </div>
                                <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3">
                                    <p class="mb-1"><strong>GC: </strong>{{ signosVitales.glucosa_capilar }}</p>
                                    <p class="mb-1"><strong>VHB: </strong>{{ signosVitales.hemoglobina }}</p>
                                    <p class="mb-1"><strong>VHC: </strong>{{ signosVitales.hemoglobina_corregida }}</p>
                                </div>
                            </div>


                            <hr>


                            <div class="row">
                                <div class="col-12 mb-2">
                                    <p class="mb-1"><strong>MOTIVO DE CONSULTA:</strong></p>
                                    <textarea :disabled="deshabilitar" v-model="historial.motivo"
                                        class="form-control tama-letra" rows="2">NO SEEEE</textarea>
                                </div>

                                <div class="col-12 mb-2">
                                    <p class="mb-1"><strong>ANAMNESIS:</strong></p>
                                    <textarea :disabled="deshabilitar" v-model="historial.anamnesis"
                                        class="form-control tama-letra" rows="2">NO SEEEE</textarea>
                                </div>

                                <div class="col-12 mb-2" v-if="historial.examenes && historial.examenes !== 'ODONTOLOGIA'">
                                    <p class="mb-1"><strong>EXÁMENES ENVIADOS:</strong></p>
                                    <textarea :disabled="deshabilitar" v-model="historial.examenes"
                                        class="form-control tama-letra" style="text-transform: uppercase;"
                                        rows="2"></textarea>
                                </div>

                                <div class="col-12 mb-2" v-if="historial.examenes && historial.examenes.toString().trim() === 'ODONTOLOGIA'">
                                    <p class="mb-1"><strong>ODONTOGRAMA:</strong></p>
                                    <div class="table-responsive">
                                        <table class="table table-bordered">
                                            <thead style="background: #d1d5db;">
                                                <tr style="font-size: 12px;">
                                                    <th>Diente</th>
                                                    <th>Posición</th>
                                                    <th>Estado</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template v-for="(item, index) in odontologia" :key="index">
                                                    <tr style="font-size: 12px;" v-if="!isDuplicateExtracted(item, index)">
                                                        <td style="text-align: center;">{{ item.numero_diente }}</td>
                                                        <td style="text-align: center;">
                                                            <template v-if="item.color === 'cross'">Total</template>
                                                            <template v-else>
                                                                {{ translateSection(item.seccion) }}
                                                            </template>
                                                        </td>
                                                        <td style="text-align: center;">
                                                            <span v-if="item.color === 'blue'" class="badge bg-primary">Restauración</span>
                                                            <span v-else-if="item.color === 'red'" class="badge bg-danger">Caries</span>
                                                            <span v-else-if="item.color === 'purple'" class="badge" style="background-color: purple; color: white;">Endodoncia</span>
                                                            <span v-else-if="item.color === 'green'" class="badge bg-success">Sellante</span>
                                                            <span v-else-if="item.color === 'cross'" class="badge bg-dark">Extraído</span>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <p class="mb-1"><strong>DIAGNÓSTICO:</strong></p>

                                    <div class="table-responsive">
                                        <table class="table table-bordered">
                                            <thead style="background: #d1d5db;">
                                                <tr style="font-size: 12px; white-space: nowrap;">
                                                    <th>CIE-10</th>
                                                    <th>ENFERMEDAD</th>
                                                    <th>TIPO</th>
                                                    <th>DESCRIPCIÓN</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr style="font-size: 12px;"
                                                    v-for="(diagnostico, index) in cargaDiagnostico" :key="index">
                                                    <td style="text-align: center;">{{ diagnostico.cie_cod }}</td>
                                                    <td style="text-align: left;">{{ diagnostico.enfermedad }}</td>
                                                    <td style="text-align: center; text-transform: uppercase;">{{
                                                        diagnostico.tipo }}</td>
                                                    <td style="text-align: center;">{{ diagnostico.description }}</td>
                                                </tr>
                                            </tbody>
                                        </table>

                                    </div>

                                </div>




                                <div class="col-12 mb-3">
                                    <p class="mb-1"><strong>TRATAMIENTO:</strong></p>
                                    <textarea :disabled="deshabilitar" v-model="historial.tratamiento"
                                        class="form-control tama-letra" rows="2">NO SEEEE</textarea>
                                </div>


                                <div class="col-12 mb-5">
                                    <p class="mb-2"><strong>LISTADO DE EVALUACIONES REALIZADAS:</strong></p>
                                    <DataTable :columns="columns" :options="options" :data="transactions"
                                        class="table tablesorter" width="100%">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Fecha/Hora</th>
                                                <th data-priority="1">Evaluación</th>
                                                <th>Médico</th>
                                            </tr>
                                        </thead>
                                    </DataTable>
                                </div>

                                <div class="col-12">
                                    <p class="mb-1"><strong>EVOLUCIÓN:</strong></p>
                                    <form role="form" autocomplete="off" @submit.prevent="guardarEvolucion">
                                        <textarea ref="observacionesTextarea" v-model="historial.observaciones" class="form-control tama-letra"
                                            rows="5"></textarea>

                                        <!-- Botón para enviar la información -->
                                        <button type="submit" class="btn btn-primary btn-sm mt-2 ms-2">
                                            <i class="fas fa-save"></i> Guardar
                                        </button>
                                    </form>
                                </div>



                            </div>


                        </div>



                    </div>
                </div>

            </div>
        </div>

    </div>


</template>


<script>
/* eslint-disable */
import { generatePdfForAtencion } from './pdfHistoriaPorAtencion';
import DataTable from 'datatables.net-vue3'
import DataTablesCore from 'datatables.net-bs5';
import 'datatables.net-responsive';


DataTable.use(DataTablesCore);

export default {
    name: "Historial-Atenciones-Resumen",
    components: {
        DataTable
    },

    data() {
        let datos = JSON.parse(localStorage.getItem("userData"));

        return {
            loading: true,
            isMobile: this.$isMobile,
            tokenAuth: localStorage.getItem("tokenAuth"),
            cod_paciente: this.$route.query.cod_paciente,
            idPaciente: this.$route.query.idPaciente,
            cod_consulta: this.$route.query.cod_consulta,
            tieneReceta: false,
            cargandoReceta: false,
            cargaConsulta: [],
            user: datos.email,
            fechas: [],
            fechaSeleccionada: null,
            deshabilitar: true,
            cargaDiagnostico: [],
            historial: {
                especialidad: '',
                doctor: '',
                motivo: '',
                anamnesis: '',
                examenes: '',
                tratamiento: '',
                observaciones: ''
            },
            signosVitales: {
                peso: '',
                talla: '',
                imc: '',
                perimetro_abdominal: '',
                perimetro_cefalico: '',
                presion_sistolica: '',
                presion_diastolica: '',
                presion_media: '',
                temperatura: '',
                frecuencia_cardiaca: '',
                saturacion_oxigeno: '',
                frecuencia_respiratoria: '',
                hemoglobina: '',
                hemoglobina_corregida: ''
            },
            infoImprimir: [],
            infoPaciente: [],
            transactions: [],
            columns: [
                { data: null, render: (data, type, row, meta) => meta.row + 1 },
                {
                    data: 'fecha',
                    render: function (data, type, row, meta) {
                        if (type === 'display' || type === 'filter') {
                            const fechaHora = new Date(data);
                            const fechaFormateada = fechaHora.toLocaleDateString('es-ES', {
                                year: 'numeric',
                                month: '2-digit',
                                day: '2-digit'
                            });
                            const horaFormateada = fechaHora.toLocaleTimeString('es-ES', {
                                hour12: false,
                                hour: '2-digit',
                                minute: '2-digit',
                                second: '2-digit'
                            });
                            return `${fechaFormateada} ${horaFormateada}`;
                        }
                        return data;
                    }
                },
                { data: 'evolucion' },
                { data: 'medico' }
            ],
            options: {
                searching: false,
                responsive: true,
                lengthChange: false,
                "ordering": false,
                columnDefs: [
                    { responsivePriority: 1, targets: 0 },
                    { responsivePriority: 2, targets: -1 }
                ],
                lengthMenu: [
                    [5, 15, 25, 35, 50, -1],
                    [5, 15, 25, 35, 50, "All"],
                ],
                pageLength: 5,
                "language": {
                    "search": "Buscar:",
                    "sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
                    "sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                    "searchPlaceholder": "Ingrese algún dato",
                    "zeroRecords": "Lo sentimos, no se encontraron resultados",
                    "processing": "Buscando. Espere por favor...",
                    "sLengthMenu": "Mostrar _MENU_ registros",
                    "oPaginate": {
                        "sFirst": "Primero",
                        "sLast": "Último",
                        "sNext": "Siguiente",
                        "sPrevious": "Anterior"
                    },

                }
            },

        };
    },
    computed: {},

    watch: {

        'historial.observaciones': function (newValue) {
            const textarea = this.$refs.observacionesTextarea;
            if (textarea) {
                const cursorPosition = textarea.selectionStart;
                this.historial.observaciones = newValue.toUpperCase();
                this.$nextTick(() => {
                    textarea.setSelectionRange(cursorPosition, cursorPosition);
                });
            }
        },

        '$route.query': {
            immediate: true, // Ejecutar el watcher inmediatamente al montar el componente
            handler(newQuery, oldQuery) {
                if (newQuery.cod_paciente !== oldQuery?.cod_paciente || newQuery.idPaciente !== oldQuery?.idPaciente || newQuery.cod_consulta !== oldQuery?.cod_consulta) {
                    this.cod_paciente = newQuery.cod_paciente;
                    this.idPaciente = newQuery.idPaciente;
                    this.cod_consulta = newQuery.cod_consulta;
                    this.tieneReceta = false;
                    this.cargaDeatallePaciente(); // Volver a cargar los datos
                }
            }
        }
    },

    activated() { },
    mounted() {


        if (this.isMobile) {
            this.$eventBus.emit("activeShowMenu");
        }

        this.cargaDeatallePaciente()


    },
    methods: {

        translateSection(section) {
            const translations = {
                'center': 'Centro',
                'top': 'Superior',
                'right': 'Derecha',
                'bottom': 'Inferior',
                'left': 'Izquierda'
            };
            return translations[section] || section;
        },

        isDuplicateExtracted(item, currentIndex) {
            if (item.color !== 'cross') return false;
            
            // Buscar si hay un registro anterior del mismo diente extraído
            for (let i = 0; i < currentIndex; i++) {
                if (this.odontologia[i].numero_diente === item.numero_diente && 
                    this.odontologia[i].color === 'cross') {
                    return true;
                }
            }
            return false;
        },

        verificarReceta() {
            this.tieneReceta = false;
            if (!this.cod_consulta) return;

            this.$https.post('/especialidades/getVerReceta', {
                codigoConsulta: this.cod_consulta,
                soloMeta: true
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.tokenAuth,
                }
            }).then(response => {
                const data = response.data || {};
                this.tieneReceta = data.code === 200 && (
                    data.existe === true || Boolean(data.ruta) || Boolean(data.pdf)
                );
            }).catch(() => {
                this.tieneReceta = false;
            });
        },

        abrirPdfBase64(base64) {
            const limpio = String(base64 || "").replace(/^data:.*?;base64,/, "").trim();
            const binario = atob(limpio);
            const bytes = new Uint8Array(binario.length);
            for (let i = 0; i < binario.length; i++) bytes[i] = binario.charCodeAt(i);
            const url = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }));
            const ventana = window.open(url, '_blank');
            if (!ventana) {
                this.$swal.fire({
                    title: "Ventana bloqueada",
                    text: "Permite las ventanas emergentes para ver la receta.",
                    icon: "warning",
                    confirmButtonText: "Aceptar",
                    customClass: { confirmButton: "btn btn-primary" },
                    buttonsStyling: false,
                });
            }
        },

        abrirRecetaFirmada() {
            if (!this.cod_consulta || this.cargandoReceta) return;

            this.cargandoReceta = true;
            this.showLoading2('Cargando receta, por favor espere...');

            this.$https.post('/especialidades/getVerReceta', {
                codigoConsulta: this.cod_consulta
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.tokenAuth,
                }
            }).then(response => {
                this.hideLoading();
                if (response.data.code === 200 && response.data.pdf) {
                    this.abrirPdfBase64(response.data.pdf);
                    return;
                }
                this.$swal.fire({
                    title: "Sin receta",
                    text: response.data.message || "No hay receta firmada para esta atención.",
                    icon: "info",
                    confirmButtonText: "Aceptar",
                    customClass: { confirmButton: "btn btn-primary" },
                    buttonsStyling: false,
                });
            }).catch(error => {
                this.hideLoading();
                if (error?.response?.status === 401) {
                    this.showSessionExpiredAlert();
                    return;
                }
                this.$swal.fire({
                    title: "No se pudo abrir",
                    text: error?.response?.data?.message || "No se pudo obtener la receta firmada.",
                    icon: "error",
                    confirmButtonText: "Aceptar",
                    customClass: { confirmButton: "btn btn-primary" },
                    buttonsStyling: false,
                });
            }).finally(() => {
                this.cargandoReceta = false;
            });
        },

        guardarEvolucion() {

            if (this.historial.observaciones === '') {
                this.showErrorMejor('LA EVOLUCIÓN NO PUEDE ESTAR VACIA')
                return
            }

            this.$https.post('/evaluacion/getSaveEvolucion', { email: this.user, evolucion: this.historial.observaciones, codigo: this.cod_consulta }, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.tokenAuth,
                }
            }).then(response => {

                if (response.data.code === 200) {

                    this.historial.observaciones = ''
                    this.cargaDeatallePaciente()
                    this.showSuccessToast('Agregado correctamente')

                }

            })

        },

        limpiar() {


            this.historial = {
                especialidad: '',
                doctor: '',
                motivo: '',
                anamnesis: '',
                examenes: '',
                tratamiento: '',
                observaciones: ''
            };

            this.signosVitales = {
                peso: '',
                talla: '',
                imc: '',
                perimetro_abdominal: '',
                perimetro_cefalico: '',
                presion_sistolica: '',
                presion_diastolica: '',
                presion_media: '',
                temperatura: '',
                frecuencia_cardiaca: '',
                saturacion_oxigeno: '',
                frecuencia_respiratoria: '',
                hemoglobina: '',
                hemoglobina_corregida: ''
            };

            this.infoImprimir = [];
            this.infoPaciente = [];
            this.odontologia = [];
            this.cargaDiagnostico = [];

        },

        async Imprimir() {

            const title = "¿Estas seguro que deseas imprimir esta ficha médica?";
            const textButton = "Imprimir";

            this.$swal({
                title: title,
                html: '',
                icon: "warning",
                width: "500px",
                showCancelButton: true,
                //input: "text",
                //inputPlaceholder: "Motivo del rechazo de solicitud",
                /* inputAttributes: {
                    autocapitalize: "off",
                } */
                confirmButtonText: textButton,
                cancelButtonText: "Cancelar",
                allowEscapeKey: true,
                customClass: {
                    confirmButton: "btn btn-primary",
                    cancelButton: "btn btn-outline-secondary ml-1",
                },
                buttonsStyling: false,
                showLoaderOnConfirm: true,
                preConfirm: () => {

                }

            }).then(async (result) => {
                if (result.isConfirmed) {
                    await generatePdfForAtencion(this.infoImprimir, this.infoPaciente, false)
                }
            })





        },

        async Imprimir2() {

            const title = "¿Estas seguro que deseas imprimir esta ficha médica?";
            const textButton = "Imprimir";

            this.$swal({
                title: title,
                html: '',
                icon: "warning",
                width: "500px",
                showCancelButton: true,
                //input: "text",
                //inputPlaceholder: "Motivo del rechazo de solicitud",
                /* inputAttributes: {
                    autocapitalize: "off",
                } */
                confirmButtonText: textButton,
                cancelButtonText: "Cancelar",
                allowEscapeKey: true,
                customClass: {
                    confirmButton: "btn btn-primary",
                    cancelButton: "btn btn-outline-secondary ml-1",
                },
                buttonsStyling: false,
                showLoaderOnConfirm: true,
                preConfirm: () => {

                }

            }).then(async (result) => {
                if (result.isConfirmed) {
                    await generatePdfForAtencion(this.infoImprimir, this.infoPaciente, true)
                }
            })





        },

        cargaDeatallePaciente() {

            if (!this.cod_consulta) {
                return
            }

            this.$https.post('/evaluacion/getLoadHistorialSeachCodigo', { codigo: this.cod_consulta }, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.tokenAuth,
                }
            }).then(response => {

                if (response.data.code === 200) {

                    this.limpiar() //limpio todo

                    this.cargaConsulta = response.data.consul[0];
                    let signos = this.cargaConsulta.consultas[0].signos_vitales
                    let consultaEncontrada = this.cargaConsulta.consultas[0]

                    this.infoPaciente = this.cargaConsulta.paciente //esto pasamos para imprimir
                    this.infoImprimir = this.cargaConsulta.consultas[0]

                    this.odontologia = this.cargaConsulta.consultas[0].odontograma

                    //SIGNOS
                    this.signosVitales.peso = signos.peso
                    this.signosVitales.talla = signos.talla
                    this.signosVitales.imc = signos.imc
                    this.signosVitales.perimetro_abdominal = signos.perimetro_abdominal
                    this.signosVitales.perimetro_cefalico = signos.perimetro_cefalico
                    this.signosVitales.presion_sistolica = signos.presion_sistolica
                    this.signosVitales.presion_diastolica = signos.presion_diastolica
                    this.signosVitales.presion_media = signos.presion_media
                    this.signosVitales.temperatura = signos.temperatura
                    this.signosVitales.frecuencia_cardiaca = signos.frecuencia_cardiaca
                    this.signosVitales.saturacion_oxigeno = signos.saturacion_oxigeno
                    this.signosVitales.frecuencia_respiratoria = signos.frecuencia_respiratoria
                    
                    //DIAGNOSTICO ES EL CUADRO
                    this.cargaDiagnostico = consultaEncontrada.diagnosticos
                

                    //EXAMENES
                    const examenesTexto = this.getExamenesConsulta(consultaEncontrada);
                    this.historial.examenes = examenesTexto


                    //ANAMNESIS - MOTIVO - TRATAMIENTO
                    this.historial.anamnesis = consultaEncontrada.motivo_consulta[0].anamnesis
                    this.historial.motivo = consultaEncontrada.motivo_consulta[0].motivo_atencion
                    this.historial.tratamiento = consultaEncontrada.tratamiento[0].tratamiento

                    //CARGA EN LA TABLA
                    this.transactions = consultaEncontrada.evolucion


                    this.historial.especialidad = consultaEncontrada.medico.especialidad
                    this.historial.doctor = consultaEncontrada.medico.doctor

                    this.verificarReceta()

                }



            }).catch(error => {



                if (error?.response?.status === 400) {
                    this.$swal.fire({
                        title: "Ocurrió algo!",
                        html: `<p style="color: #eb1265; font-weight: bold; font-size: 13px;">${error.response.data.message}</p>`, // Usa HTML para darle formato
                        icon: "warning",
                        width: "400px",
                        customClass: {
                            confirmButton: "btn btn-primary",
                            cancelButton: "btn btn-outline-secondary ml-1",
                        },
                        buttonsStyling: false,
                    });
                }


                if (error?.response?.status === 401) {
                    this.showSessionExpiredAlert()
                }



            })
        },

        getExamenesConsulta(consulta) {
            if (!consulta || !consulta.examenes) {
                return "No hay exámenes registrados.";
            }

            // Si es odontología, retornar directamente
            if (consulta.medico.especialidad === 'ODONTOLOGIA') {
                return 'ODONTOLOGIA';
            }

            let resultado = "";

            // Recorremos cada categoría de exámenes
            Object.keys(consulta.examenes).forEach(categoria => {
                if (categoria !== "otros_examenes") {
                    const examenes = consulta.examenes[categoria];

                    resultado += `🩺 ${categoria} => `;

                    // Unimos los exámenes en la misma línea con "-"
                    resultado += examenes.map(examen => examen.examen).join(" - ") + "\n";
                }
            });

            // Agregar "otros_examenes" si existe
            if (consulta.examenes.otros_examenes) {
                resultado += `📌 Otros Exámenes: => ${consulta.examenes.otros_examenes}`;
            }

            return resultado.trim(); // Quitamos espacios extra al final
        },



    }

}



</script>


<style scoped>
@import "datatables.net-dt";
@import 'datatables.net-responsive-dt';

.tama-letra {
    font-size: 13px;
}

.profile-img {
    width: 220px;
    height: 220px;
    background-color: #cce5ff;
    border-radius: 70%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 40px;
    font-weight: bold;
    color: #0078be !important;
    border: 6px solid white;
    position: relative;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.2);
}

.profile-initials {
    text-transform: uppercase;
}

.card-header {
    font-weight: bold;
    background: #0078be !important;
}

.card-container {
    background: white;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.2);
    /* transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out; */
}

.acciones-seguimiento {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}

.acciones-seguimiento .fa-print {
    font-size: 1.25rem;
    line-height: 1;
}

.btn-ver-receta {
    background-color: #0078be;
    color: #fff;
    border: none;
    padding: 5px 12px;
    border-radius: 5px;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
}

.btn-ver-receta:hover:not(:disabled) {
    background-color: #005f96;
    color: #fff;
}

.btn-ver-receta:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}
</style>
